let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hNk7k")).then(() => parcelRequire('guYPm'));